<template>
  <div style="text-align: right;padding-right: 20px;">
    <el-button type="primary" @click="btnAddAupplier" tkey="添加供應商">{{i18n.tkey("lang_add")}}{{i18n.tkey("lang_join_hall_company")}}</el-button>
  </div>
    <div v-loading="loading">
        <div v-show="viewPart === 'list'">
            <img style="height: 200px;" :src="`${publicPath}static/images/20250319190601.png`" />
            <HallCompanyList
                :list="dataList"
                :type="type"
                @del-success="delCallback"
                @save-success="saveCallback"
                @clickEdit="goEdit"
            />

            <PaginationComponent
                :pageObj="pageObj"
                @goPage="clickPage"
                v-if="dataList.length > 0 || pageNum > 1"
            />
        </div>

        <div>
            <el-dialog
                v-model="openEditVisible"
                :title="i18n.tkey('lang_modify')"
                :width="myUtil.isMobile() ? '90%' : '600px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
            >
                <MoveHallPosition
                    :record="editRecord"
                    @save-complete="savePositionCallback"
                />
            </el-dialog>
        </div>
      <div>
        <el-dialog
            v-model="addsupplierVisible"
            :title="i18n.tkey('lang_add')+i18n.tkey('lang_join_hall_company')"
            :width="myUtil.isMobile() ? '90%' : '600px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
          <div >
            <el-row  >
              <el-col :span="12"  v-for="(v, i) in invataionList" :key="i + new Date().getTime()">
                <el-row style="padding: 8px;border-bottom: 1px #d9d9d9 solid;" @click="chengSelect(v,i)">
                  <el-col :span="24" style="text-align: left">
                    <span tkey="公司名稱">{{i18n.tkey("lang_company_name")}} : {{v.companyname}}</span>
                  </el-col>

                  <el-col :span="24"  style="text-align: left">
                    <span tkey="電子郵箱">{{i18n.tkey("lang_email")}} : {{v.login}}</span>
                  </el-col>
                  <el-col :span="24"  style="text-align: left">
                    <span tkey="姓名">{{i18n.tkey("lang_name")}} : {{v.name}}</span>
                  </el-col>

                  <el-col :span="24" style="text-align: left">
                    <span tkey="激活時間">{{i18n.tkey("lang_activate_time")}} : {{v.addinfo6}}</span>

                    <img v-if="v.isChecked" :src="`${publicPath}static/images/choose.png?v=1`" style="width: 60px;margin-top: -75%;" onerror="this.error = null">
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-button type="primary" @click="getMaxStoreNumber()" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
            <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="invataionList.length === 0">

            </el-empty>
          </div>

        </el-dialog>
      </div>


    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, toRef} from "vue";
import record15Api from "@/request/record15Api";
import myUtil from "@/util/util";
import HallCompanyList from "@/components/shopopee/hallManager/hallCompanyList.vue";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import MoveHallPosition from "@/components/shopopee/hall/moveHallPosition.vue";
import invitaionApi from "@/request/invitaionApi";
import util from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import ImgCropper from "@/components/shopopee/form/imgCropper.vue";
const publicPath = process.env.BASE_URL

const props = defineProps(["hallObj", "type"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const loading = ref(false)
const viewPart = ref("list")
const openEditVisible = ref(false)

const pageNum = ref(1)
const pageSize = ref(100)
const pageObj = ref({})
const dataList = ref([])
const editRecord = ref(null)
const invataionList = ref([])

const queryType = ref(0)
const addsupplierVisible = ref(false)

var layerNum = 1
var costsNum = 1
function getHallRecord15ByPage(){
    loading.value = true

    const request = record15Api.getRecord15ListandCompanyByPage
    const params = request.getParams()

    params.recordno = null
    params.updatedid = props.hallObj.id
    params.pageNum = pageNum.value
    params.pageSize = pageSize.value

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            const obj = res.detail

            pageObj.value = obj
            dataList.value = obj.list

        }else{
            myUtil.alertError(res.msg)
        }
    })


}
function btnAddAupplier(){
  addsupplierVisible.value = true
  getInvRecord()
}
function clickPage(num){
    pageNum.value = num

    getHallRecord15ByPage()
}

function submitSelect(){
  console.log(invataionList.value.length)
  for (let i = 0; i < invataionList.value.length; i++) {
    if(invataionList.value[i].isChecked){
      if(costsNum==20){
        layerNum = layerNum+1
        costsNum = 1
      }else {
        costsNum = costsNum+1
      }
      addExhibitionCompany(invataionList.value[i])
      invataionList.value[i].isChecked = false;
      if(i==invataionList.value.length-1){
        loading.value =false
        addsupplierVisible.value = false
        getHallRecord15ByPage()
      }
      return
    }
    if(i==invataionList.value.length-1){
       loading.value =false
      addsupplierVisible.value = false
      getHallRecord15ByPage()
    }
  }
}
function addExhibitionCompany(dataCompanInfo){

  const request = record15Api.insertAdditionalrecord15
  const params = request.getParams()

  params.addinfo1 = layerNum
  params.addinfo2 = costsNum
  params.addinfo13 = props.hallObj.addinfo7
  params.companycode = dataCompanInfo.companycode
  params.updatedid = props.hallObj.id
  params.historydatetime = util.formatDate(new Date(), 'yyyy/MM/dd hh:mm:ss')
  params.login = userInfoRef.value.login
  params.recordno = -1
  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){
      var data = res.detail

      submitSelect()

    }else{
      loading.value =false
      myUtil.alertError(res.msg)
    }
  })
}

function getMaxStoreNumber(){
  loading.value = true

  const request = record15Api.queryMaxStoreNumber
  const params = request.getParams()

  params.updatedid = props.hallObj.id

  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){
        var data = res.detail
        if (util.isNotEmpty(data)){
          layerNum = parseInt(data.addinfo1)
          costsNum = parseInt(data.addinfo2)
        }
      submitSelect()

    }else{
      loading.value = false
      myUtil.alertError(res.msg)
    }
  })

}

function saveCallback(){
    getHallRecord15ByPage()
}

function delCallback(){
    if (dataList.value.length === 1 && pageNum.value > 1){
        pageNum.value -= 1
    }

    getHallRecord15ByPage()
}

function goEdit(obj){
    editRecord.value = obj
    openEditVisible.value = true
}

function savePositionCallback(){
    editRecord.value = null
    openEditVisible.value = false
    getHallRecord15ByPage()
}


function chengSelect(v,i){
  invataionList.value[i].isChecked = !invataionList.value[i].isChecked
}




function getInvRecord() {
  const request = invitaionApi.queryAdditionalrecord10InfoList
  const params = request.getParams()
  params.addinfo1 = props.hallObj.companycode
  request.send(
      params, (res) => {
        if (res.code == 200){
          fillInvRecord(res.detail)
        }else{
          myUtil.alertError(res.msg)
        }
      })
}
function fillInvRecord(list) {
  invataionList.value = []
  list.forEach((v, i) => {
    var ishas = false
    for (let j = 0; j < dataList.value.length; j++) {
      if(v.companycode == dataList.value[j].companycode){
        ishas = true
        break
      }
    }
    if (!ishas){
    const objInvrecord = {}
    objInvrecord.login = v.login
    objInvrecord.name = v.name
    objInvrecord.addinfo6 = v.addinfo6
    objInvrecord.password = v.password
    objInvrecord.addinfo3 = v.addinfo3
    objInvrecord.memberworkid = v.memberworkid
    objInvrecord.invLogin = util.isEmpty(v.invLogin) ? "" : v.invLogin
    objInvrecord.invName = util.isEmpty(v.invName) ? "" : v.invName
    objInvrecord.companyname = util.isEmpty(v.companyname) ? "" : v.companyname
    objInvrecord.companycode = util.isEmpty(v.companycode) ? "" : v.companycode
    objInvrecord.isChecked= false

    if (util.isEmpty(objInvrecord.name) || "null" == objInvrecord.name) {
      if (v.updatedid == 0) {
        objInvrecord.name = "未激活"
      } else {
        objInvrecord.name = "已註銷的賬戶"
      }
    }

    if (util.isEmpty(objInvrecord.addinfo6) || "null" == objInvrecord.addinfo6) {
      if (v.updatedid == 0) {
        objInvrecord.addinfo6 = "未激活"
      } else {
        objInvrecord.addinfo6 = ""
      }
    }

    if (util.isEmpty(objInvrecord.password) || "null" == objInvrecord.password) {
      if (util.isNotEmpty(v.addinfo12) && "null" != v.addinfo12) {
        objInvrecord.password = v.addinfo12
      } else {
        objInvrecord.password = ""
      }
    }

    invataionList.value.push(objInvrecord)

    }
  })
}

onBeforeMount(() => {
    if (null != props.type){
        queryType.value = props.type
    }

    getHallRecord15ByPage()
})

</script>

<style scoped>

</style>